import React from "react";
import styled from "styled-components";
import theme from "@/styles/theme";

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 48px;
  margin-bottom: ${theme.spacing.unit * 1}px;
`;

const Title = styled.div`
  padding: ${theme.spacing.unit * 1}px 0;
  margin-bottom: ${theme.spacing.unit * 1}px;

  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 30px;
`;

const ContentHeader = (props) => {
  const { left, title, right } = props;

  return (
    <>
      {(left || right) && (
        <ButtonsContainer>
          {left || <div></div>}
          {right}
        </ButtonsContainer>
      )}
      {title && <Title>{title}</Title>}
    </>
  );
};

export default ContentHeader;
